import React from 'react';
import { Link } from 'react-router-dom';
import './InsightsHero.css';

// 1. Import the new device image
import devicesImage from '../../assets/images/insights-devices.png';

const InsightsHero = () => {
  return (
    <section className="insights-hero-section">
      <div className="insights-hero-content">
        <h1>Insights that empower decisions</h1>
        <p>
          Get in-depth insights, quick updates, and expert analysis to know what's keeping the market on the move.
        </p>
        <div className="insights-hero-buttons">
          <button className="cta-button primary">Follow WhatsApp Channel</button>
          <Link to="/signup">
            <button className="cta-button secondary-outline">Book a demo</button>
          </Link>
        </div>
      </div>
      <div className="insights-hero-graphic">
        {/* 2. Replace the old div with the new img tag */}
        <img src={devicesImage} alt="CRISHI Insights on multiple devices" />
      </div>
    </section>
  );
};

export default InsightsHero;